import React, { useContext } from "react";
import { useRoleFeature } from "./context/RoleFeatureContext";
const withFeatureActions = (WrappedComponent, source, componentName) => {
  return (props) => {
const { roleFeatureList } = useRoleFeature();

    const sourceFeatures = roleFeatureList?.features?.find(
      (featureGroup) => featureGroup.source === source
    );

    const matchedFeature =
      sourceFeatures?.featureList?.find(
        (feature) => feature.componentName === componentName
      ) ||
      sourceFeatures?.featureList
        ?.flatMap((feature) => feature.subFeatures || [])
        ?.find((sub) => sub.componentName === componentName);

    const permissions = {
      readAccess: matchedFeature?.readAccess || false,
      writeAccess: matchedFeature?.writeAccess || false,
      modifyAccess: matchedFeature?.modifyAccess || false,
    };

    return <WrappedComponent {...props} featureAccess={permissions} />;
  };
};

export default withFeatureActions;
